/* @flow */

import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';
import NavigationService from 'services/NavigationService';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

@translate()
@inject('projectDetailsStore')
@observer
class AssignedToProject extends React.Component<*> {
  render(): ?React.Element<*> {
    const t: Function = this.props.t;
    const details: any = this.props;

    const isLinkDisabled: Function = (len: number) =>
      `${'layout-button' + (len === 0 ? ' disabled' : '')}`;

    return (
      <React.Fragment>
        <h3>{t('general:assets.assigned_to_project')}</h3>
        <table className="layout-table large-first-col">
          <tbody>
            <tr>
              <td>{t('general:assets.all')}</td>
              <td className="layout-flex">
                <div>
                  <span>{details.all}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [this.props.id] },
                        { key: 'asset_type', values: ['Rented Open', 'Owned', 'Purchased'] },
                      ],
                    })}
                    className={isLinkDisabled(details.all)}
                  >
                    <Button variant="contained" color="primary" disabled={details.all === 0}>
                      {t('general:actions.view_asset', {
                        count: details.all,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>{t('general:assets.rented_asset_plural')}</td>
              <td className="layout-flex">
                <div>
                  <span>{details.rented}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [this.props.id] },
                        { key: 'asset_type', values: ['Rented Open'] },
                      ],
                    })}
                    className={isLinkDisabled(details.rented)}
                  >
                    <Button variant="contained" color="primary" disabled={details.rented === 0}>
                      {t('general:actions.view_asset', {
                        count: details.rented,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
            <tr>
              <td>{t('general:assets.owned_asset_plural')}</td>
              <td className="layout-flex">
                <div>
                  <span>{details.owned}</span>
                  <Link
                    to={NavigationService.formulateReportViewUri('/assets', {
                      page: 1,
                      filters: [
                        { key: 'project', values: [this.props.id] },
                        { key: 'asset_type', values: ['Owned'] },
                      ],
                    })}
                    className={isLinkDisabled(details.owned)}
                  >
                    <Button variant="contained" color="primary" disabled={details.owned === 0}>
                      {t('general:actions.view_asset', {
                        count: details.owned,
                      })}
                    </Button>
                  </Link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </React.Fragment>
    );
  }
}

export default AssignedToProject;
